export default __webpack_public_path__ + "static/media/export_ply.682f0095.svg";